export default class JObject {
  private value: Record<string, any>
  constructor(value?: any) {
    try {
      if (typeof value === 'string') {
        this.value = JSON.parse(value ?? '{}')
      } else {
        this.value = value ?? {}
      }
    } catch (error) {
      this.value = {}
    }
  }
  static fromJson(value?: any) {
    return new JObject(value)
  }
  toValue = <T extends Record<string, any>, TK extends keyof T = keyof T>(key: TK): T[TK] | undefined => {
    return this.value[key as any]
  }
  toJObject = <T extends Record<string, any>, TK extends keyof T = keyof T>(key: TK): JObject => {
    return new JObject(this.value[key as any])
  }
  setValue = <T extends Record<string, any>, TK extends keyof T = keyof T>(key: TK, value: any) => {
    this.value[key as any] = value
  }
  toObject = <T>(): Partial<T> => {
    return this.value as T
  }
}
